<div>
  <section id="tinyslider">
    <!-- <div class="dark"
      style="background-image: linear-gradient(rgb(5 2 26 / 80%) 0%, rgb(0 0 0 / 90%) 100%), url('https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202161813718-883blogsvidhema.jpg');background-position: center top;">
      <div class="container clearfix">

        <div class="slider-caption slider-caption-center">

          <h1>Explore Latest from the IT World with Vidhema</h1>

          <p>No global movement springs from individuals. It takes an entire team united behind something big. Together,
            we work hard, we laugh a lot, we brainstorm nonstop,and are passionate about the company and our values.</p>

        </div>

      </div>
    </div> -->

    <div class="blog-detail-banner" style="" id="post-32546" >
      <div class="blog-detail-banner-content">
         <div class="container">
            <div class="flex_panel">
              <div class="blog_banner_left">
                <h1 class="blog_h1">{{BlogData?.title}}</h1>
                <div class="blog_writes">
                  <span class="author_nm">{{BlogData?.author?.name}}</span>
                  <span class="dot"></span>
                  <span class="blog_dt">{{formateDate(BlogData?.date)}}</span>
                </div>
               </div>
               <!-- <div class="blog_banner_right ">
                   <figure>
                          <img *ngIf="BlogData?.backgroundImage == ''" src="assets/images/services/common/ios-app-development.png" alt="app development cost" title="app development cost">
                        <img *ngIf="BlogData?.backgroundImage != ''" [src]="BlogData?.backgroundImage" alt="app development cost" title="app development cost">
                         
                        <img src="assets/images/services/common/ios-app-development.png" alt="app development cost" title="app development cost">
                   </figure>
               </div> -->
            </div>
         </div>
      </div>
   </div>
  </section>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/index.html">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/blog">Blog</a></li>
      <li class="breadcrumb-item active" aria-current="page">{{BlogData?.title}}</li>
    </ol>
  </nav>
  
  <section id="content" class="servesdetails blog blog-Det" style="background-image: linear-gradient(rgba(252, 252, 255, 0.8) 100%, rgba(0, 0, 0, 0.2) 100%), url({{randimage}});background-attachment:fixed;background-position: center;background-size: cover;">
    <div class="content-wrap" id="vidhema_content">
      <div class="container clearfix">

        <div class="row clearfix">


        </div>

      </div>

      <div class="section nobottommargin" id="serviceslist" style="background-color:transparent">


        <div id="servicedetailss" class="container-fluid" >
          <div class="container-fluid clear-bottommargin clearfix" id="servicedetails">


            <div *ngIf="BlogData && BlogData.metatags" class="col-md-8 col-xs-12 col-sm-12">
              <div class="col-md-12 col-sm-12 col-xs-12 largecontentdiv listser">
                <div class="blog-content blogcontent-ss">


                  <!-- <h3 class="left"><span>{{BlogData.title}}</span></h3>
                  <p class="type-date">{{BlogData.technology}} / {{formateDate(BlogData.date)}}</p> -->
<!-- 
                  <h5 class="left text-center"><img src="{{BlogData.metatags.imgUrl}}" alt="BlogData.metatags.imgAlt"
                      title="BlogData.metatags.imgTitle"></h5> -->
                  <p class="content-blog-small" innerHtml={{BlogData.description}}> </p>
                  
                  <section class="faq-section">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12 mx-auto text-center">
                          <h2>Frequently Asked Questions</h2>
                          <p>A lot of people don't appreciate the moment until it’s passed. I'm not trying my hardest, and I'm not
                            trying to do </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 mx-auto">
                          <div  class="accordion" id="accordionRental">
                            <div class="accordion-item" *ngFor="let data of BlogData?.otherDetails;let i = index;">
                              <h5 class="accordion-header accordion-box-heading" id="{{'heading'+i}}">
                                <button class="accordion-button border-bottom font-weight-bold collapsed" type="button"
                                  data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse'+i" 
                                   aria-expanded="false"
                                  aria-controls="collapse">
                                  <span>{{data?.faq}}</span>
                                  <div class="action-button">
                                    <i class="collapse-close fa fa-plus text-xs pt-1 position-absolute end-0"></i>
                                    <i class="collapse-open fa fa-minus text-xs pt-1 position-absolute end-0"></i>
                                  </div>
                                </button>
                              </h5>
                              <div id="{{'collapse'+i}}" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading'+i"
                                data-bs-parent="#accordionRental" style="">
                                <div [innerHTML]="data.answer" class="accordion-body accordion-body-dy text-sm opacity-8">
                             x     {{data?.answer}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <div class="aboutauthorsection">

                    <h4 class="about_auth">About Author</h4>
                    <div class="authorinfosection">

                      <div class="about_authimg">
                        <img src="{{BlogData?.author?.image}}" alt="OWNER IMAGE">
                      </div>
                      <div class="about_authtext">
                        <h5>{{BlogData?.author?.name}}</h5>
                        <p>
                          {{BlogData?.author?.desc}}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <h4 class="recent-blogs">Recent Blogs</h4>
              <div class="row">

                <div *ngFor="let blog of filterdata" class="blog-list-item aos-init aos-animate col-md-12" data-item="latest"
                    data-aos="fade-up">
                    <div id="post-2337" class="blog-list-card">
                      <div class="blog-list-card-thumb">
                        <a href="{{blog.url}}"><img width="900" height="553" src="{{blog.featured_image}}"
                            class="attachment-blog-card size-blog-card wp-post-image" alt="Embrace-IoT-for-Startups"
                            decoding="async" loading="lazy"></a>
                      </div>
                      <div class="blog-list-card-content">
                        <span class="blog-meta">{{blog.date | date:'longDate'| titlecase}}</span>
                        <h3 class="blog-title"><a href="{{blog?.url}}" title="{{blog.title}}">
                            {{blog.title}}</a></h3>
                            <p>{{ trimString(blog?.shortDescription,50)}}<a class="readmore" href="{{blog.url}}">Read More</a></p>
    
                            <img alt="" src="{{blog.authorId.image}}" class="avatar avatar-51 photo" height="51" width="51"
                              loading="lazy" decoding="async">
                            <div class="blog-list-footer-in">
                              <h4>{{blog.authorId.name}}</h4>
                              <span>Posts by this author</span>
                            </div>
                      </div>
                      
    
                    </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="text-center social-icons">
        <button class="social linkedin"  (click)="openSocial('linkedin')">
          <i class="fa fa-linkedin"></i> 
        </button>
        <!-- <button class="social facebook"  (click)="openSocial('facebook')">
          <i class="fa fa-facebook"></i> 
        </button> -->
  
        <button class="social skype" (click)="openSocial('skype')">
          <i class="fa fa-skype"></i> 
        </button>
  
        <button class="social whatsapp"  (click)="openSocial('whatsapp')">
          <i class="fa fa-whatsapp"></i> 
        </button>
  
        <button class="social twitter"  (click)="openSocial('twitter')">
          <i class="fa fa-twitter" aria-hidden="true"></i>  
        </button>
      </div>
      <h5 class="text-center" style="font-size: 2rem;font-weight: 500;font-size: 2rem;font-weight: 500;padding-bottom: 29px;">Share it</h5>
    </div>
<!-- 
    <div class="prev-nxt prev" *ngIf="previous?.url">
      <button  (click)="authblogpre()">previous</button>
    </div>
    <div class="prev-nxt next" *ngIf="next?.url">
      <button  (click)="authblognex()">next</button>
    </div> -->

    

    <app-quoteform></app-quoteform>

  </section><!-- #content end -->



  <a href="#" id="back-to-top" title="Back to top"><i class="fa fa-arrow-up"></i></a>
</div>